import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export function loadUserSubscription(previewProrated) {
  return axios
    .get(`${BASE_URL}/subscription?previewProrated=${previewProrated}`)
    .then(({ data }) => data);
}

export function editPaymentDetails(id, details) {
  return axios
    .patch(`${BASE_URL}/subscription/${id}`, details)
    .then(({ data }) => data);
}

export function updateUsernameService(username) {
  return axios
    .patch(`${BASE_URL}/updateAppUsername`, { username })
    .then(({ data }) => data);
}

export function customerMockUpService(customer) {
  return axios
    .post(`${BASE_URL}/userVerification`, {
      customer,
    })
    .then(({ data }) => data);
}

export function getCustomerMockUp() {
  return axios.get(`${BASE_URL}/getUserVerification`).then(({ data }) => data);
}

export function updatePersonalData(personalData) {
  return axios
    .patch(`${BASE_URL}/updatePersonalData`, personalData)
    .then(({ data }) => data);
}

export function updateProfilePrivacyService(privacy) {
  return axios
    .patch(`${BASE_URL}/updateUserProfilePrivacy`, { privacy })
    .then(({ data }) => data);
}

export function updateFlashcardOnlyService(payload) {
  return axios
    .patch(`${BASE_URL}/updateFlashcardOnly`, payload)
    .then(({ data }) => data);
}

export function updateSwitchPfeSktService(rateId) {
  return axios
    .patch(`${BASE_URL}/updateCurrentRateId`, { rateId })
    .then(({ data }) => data);
}

export function updateTimezoneService(zone) {
  return axios
    .patch(`${BASE_URL}/updateUserTimezone`, { zone })
    .then(({ data }) => data);
}

export function updateEmailService(email) {
  return axios
    .patch(`${BASE_URL}/updateUserEmail`, { email })
    .then(({ data }) => data);
}

export function updatePasswordService(oldPassword, newPassword) {
  return axios
    .patch(`${BASE_URL}/updatePassword`, {
      oldPassword,
      newPassword,
      updateWithoutConfirmation: true,
    })
    .then(({ data }) => data);
}

export function getAllPublicRates() {
  return axios.get(`${BASE_URL}/rate`).then(({ data }) => data);
}

export function loadPossibleCyclesForUser(user) {
  const queryParam = `?dutyState=${user.dutyState}&rank=${user.rank}`;
  return axios
    .get(`${BASE_URL}/cycle/findCyclesByUser${queryParam}`)
    .then(({ data }) => data);
}

export function loadPossibleCyclesForUpdateExam(rate, rank, dutyState) {
  const queryParam = `?rate=${rate}&dutyState=${dutyState}&rank=${rank}`;
  return axios
    .get(`${BASE_URL}/cycle/cycleByUpdateExam${queryParam}`)
    .then(({ data }) => data);
}

export function updateRatingExam(user) {
  return axios
    .patch(`${BASE_URL}/${user.id}/updateExam/`, {
      editingProfile: true,
      id: user.id,
      updateFields: {
        rank: user.rank,
        dutyState: user.dutyState,
        cycleSelected: user.cycleSelected,
        rate: user.rate,
      },
    })
    .then(({ data }) => data);
}

export function uploadProfileImage(imgFile) {
  // eslint-disable-next-line prefer-const
  let formData = new FormData();
  formData.append('imgFile', imgFile);
  return axios
    .post(`${BASE_URL}/updateUserProfileImage`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(({ data }) => data);
}

export function getDisabledQuestionsService(limit = 50, skip = 0) {
  return axios
    .post(`${BASE_URL}/getDisabledQuestions`, { limit, skip })
    .then(({ data }) => data);
}

export function getFavoriteQuestionsService(limit = null, skip = null) {
  return axios
    .post(`${BASE_URL}/getFavoriteQuestions`, { limit, skip })
    .then(({ data }) => data);
}

export function getSubmittedQuestionsService() {
  return axios
    .get(`${BASE_URL}/questionSubmit/getQuestionsSubmittedForUser`)
    .then(({ data }) => data);
}

export function removeFavoriteQuestionsService(userId, questionsId) {
  return axios
    .post(`${BASE_URL}/removeFavoriteQuestions`, {
      userId,
      questionsId,
    })
    .then(({ data }) => data);
}

export function removeAllFavoriteQuestionsService() {
  return axios
    .post(`${BASE_URL}/removeAllFavoriteQuestionsForUser`)
    .then(({ data }) => data);
}

export function resetAllDisabledQuestions() {
  return axios
    .patch(`${BASE_URL}/resetAllDisabledQuestions`)
    .then(({ data }) => data);
}

export function resetIndividualQuestionService(questionId) {
  return axios
    .patch(`${BASE_URL}/resetDisabledQuestion`, { questionId })
    .then(({ data }) => data);
}

export function getNotificationPreferencesService() {
  return axios
    .get(`${BASE_URL}/getNotificationPreferences`)
    .then(({ data }) => data);
}

export function sendNotificationPreferencesService(meta_key, meta_value) {
  return axios
    .patch(`${BASE_URL}/updateNotificationPreference`, {
      meta_key,
      meta_value,
    })
    .then(({ data }) => data);
}

export function activateQuestionsNotificationService(active, description) {
  return axios
    .post(`${BASE_URL}/activeAvailableQuestionNotification`, {
      active,
      notificationData: description,
    })
    .then(({ data }) => data);
}

export async function applyCouponUser(coupon) {
  return axios
    .post(`${BASE_URL}/applyCouponUser`, {
      coupon,
    })
    .then(({ data }) => data);
}

export async function getLastCouponUser() {
  return axios.get(`${BASE_URL}/getLastCouponUser`).then(({ data }) => data);
}

export async function setStudySpeedSettings(option) {
  return axios
    .patch(`${BASE_URL}/updateStudySpeed`, { studySpeed: option })
    .then(({ data }) => data);
}

export async function getQualsAvailableForDailyQuiz() {
  return axios
    .get(`${BASE_URL}/getQualsAvailableForDailyQuiz`)
    .then(({ data }) => data);
}

export function getCustomSyncService() {
  return axios.get(`${BASE_URL}/getCustomSync`).then(({ data }) => data);
}

export function updateCustomSyncService(customSync) {
  return axios
    .patch(`${BASE_URL}/updateCustomSync`, { customSync })
    .then(({ data }) => data);
}
